import { Box, Typography } from "@mui/material";

interface TOfferOrderQuantityComponentProps {
    item: any;
}

const OfferOrderQuantityComponent = (props: TOfferOrderQuantityComponentProps) => {
    const quantity = props.item.orderedQuantity || props.item.requestedQuantity
    return (
        <Box>
            <Typography variant="h6">{quantity} {props.item.unitOfMeasure}</Typography>
        </Box>
    );
};

export default OfferOrderQuantityComponent;